import { Heading } from '@h2/components/typography/heading'

const PromotionHeading = ({ children, variant }) => (
  <Heading level={variant === 'continue' ? '2' : '4'} mb="8px">
    {children}
  </Heading>
)

export { PromotionHeading }
